
import PropTypes from 'prop-types'
import React from 'react'
import { ASSET_BASE_URL } from 'config'
import css from './LoggedOutHeader.module.css'

const LoggedOutHeader = ({ title }) => (
  <header className={css.main}>
    <div className={css.logo}>
      <img src={`${ASSET_BASE_URL}/logos/segment-icon.svg`} alt='Segment' />
    </div>
    <h1>{title}</h1>
  </header>
)

LoggedOutHeader.propTypes = {
  title: PropTypes.string
}

export default LoggedOutHeader



// WEBPACK FOOTER //
// ./components/LoggedOutHeader.js